// KPI Excel/DOCX indirme sorgu yardımcıları (TODO-KPI-09 — çıktı dili). Saf; test edilir.
import { KPI_DEFAULT_LANG, type KpiLang } from "@mahir/shared";

/** `?years=2024,2025&lang=en` — varsayılan dil (tr) sorguya YAZILMAZ (sunucu çıktısı byte-eşit kalır). */
export function buildKpiExportQuery(years: number[], lang?: KpiLang): string {
  const q = new URLSearchParams();
  if (years.length > 0) q.set("years", years.join(","));
  if (lang && lang !== KPI_DEFAULT_LANG) q.set("lang", lang);
  const s = q.toString();
  return s ? `?${s}` : "";
}
